import { useMutation } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import type {
  ILoginOkResponse,
  ILoginRequest,
} from '~/@api/generated-api-types-user/Api'

export type LoginRequest = ILoginRequest

function useLoginMutation(onSuccess: (data: ILoginOkResponse) => void) {
  const { user } = useApiClientUser()

  const loginMutation = useMutation({
    mutationFn: (props: LoginRequest) => {
      return user
        .authControllerLogin(props, { secure: true })
        .then(({ data }) => data)
    },
    onSuccess,
  })

  return {
    loginUser: loginMutation.mutate,
    isRequesting: loginMutation.isPending,
    error: loginMutation.error,
    handleReset: loginMutation.reset,
  }
}

export { useLoginMutation }
